import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import InputGroup from "../../elements/inputGroup/InputGroup";
import { closableNotification } from "../../elements/notification/ClosableNotification";

import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import {games, responseStatus} from "../../../utils/consts";

import { StyledButton } from "../../styles/styledButton";
import { StyledBallsBetOptions } from "./styledBalls";
import { useBetween } from "use-between";
// import calculateGameStatistics from "../../../utils/calculateGameStatistics";
import BetAction from "../../elements/betAction/BetAction";
import AutoBetsContainer from "../../elements/autoBets/AutoBetsContainer";
import { CurrentHonestyControl } from "../../elements/leftSidebar/HonestyControl/CurrentHonestyControl";
import { VisibleLeftSidebarStates } from "../../elements/leftSidebar/VisibleLeftSidebarStates";
import { useAutoBetsStatesBalls } from "../../elements/autoBets/AutoBetsStates";
import BalanceStates from "../BalanceStates";
import { GAMES } from "../Constants";
import { useAnimationSync } from '../AnimationSyncDataStates';
import CurrentStatisticsStates from "../CurrentStatisticStates";
import {useHotkeys} from "react-hotkeys-hook";
import {AppContext} from "../../../App";
import {getCurrentGame} from "../../../utils/online";
import Big from "big.js";
import {formatNumber} from "../../../utils/formatNumber";


const BallsToPlayContainer = ({
  submitData,
  setSubmitData,
  responseData,
  setResponseData,
  errorData,
  setErrorData,
  handleChange,
  isRunMagnet,
  setIsRunMagnet,
  winAmount,
  isMobile,
  animationDisabled,
}) => {
  const { t } = useTranslation("games");

  const { autoModeIsStart, gameInfoRef, isDisableAutoBet } = useAutoBetsStatesBalls();
  const { currentHonestyControl, setLastHonestyControl, lastHonestyControl } = useBetween(CurrentHonestyControl);
  const { visible, chatIsClicked } = useBetween(VisibleLeftSidebarStates);
  const { balance, setBalance, selectedPaymentMethod, setPaymentMethods } = useBetween(BalanceStates);
  const {
    updateStatistics
  } = useBetween(CurrentStatisticsStates);
  const { startAnimationSync, stopAnimationSync } = useAnimationSync();

  const { hotkeys } = useContext(AppContext);
  const { hotkeysDisabled } = hotkeys;

  const suggestedNumbers = JSON.parse(submitData?.suggestedNumbers);

  const { clientSeed } = currentHonestyControl || {};

  const betLock = useRef(false);
  const rollButtonRef = useRef(null);

  const [lastServerSeedHash, setLastServerSeedHash] = useState(lastHonestyControl?.[games.balls]?.serverSeedHash);

  useEffect(() => {
    if (currentHonestyControl?.[games.balls]?.serverSeedHash === lastServerSeedHash) return;
    betLock.current = false;
    setLastServerSeedHash(currentHonestyControl?.[games.balls]?.serverSeedHash);
  }, [currentHonestyControl?.[games.balls]?.serverSeedHash])

  const toPlay = (manualMode = true) => {
    if (!submitData?.bet || submitData?.bet <= 0) {
      setErrorData({ error: true, terminate: true });
      return closableNotification('Minimum amount is 0.00000001', "error");
    }
    setResponseData((prevState) => ({ ...prevState, drawnNumber: undefined, error: false }));
    betLock.current = true;
    setIsRunMagnet(true);

    let data = {
      bet: submitData.bet.toString(),
      clientSeed,
      isActiveStatistic: visible,
      paymentMethod: selectedPaymentMethod.id,
      serverSeedHash: currentHonestyControl?.[games.balls]?.serverSeedHash,
      suggestedNumbers: submitData.suggestedNumbers.toString(),
    };
    startAnimationSync();

    axios.post("/api/balls", data, userAuthenticationConfig(false)).then(response => {
      if (response.status === responseStatus.HTTP_CREATED) {
        // console.log('calculateGameStatistics', response.status);
        // setStatistic(calculateGameStatistics(response.data, 'balls'));
        response.data["manualMode"] = manualMode;
        if (!gameInfoRef.current.isLeavePage) {
          console.log(
            'Баланс після ставки:',
            response.data.balance,
            (parseFloat(response.data.lose) !== 0 ?
                `(-${response.data.lose})` :
                `(+${response.data.win})`
            ),
            // `(${response.headers['request-duration']}ms)`
          );
          setBalance(prevState => {
            const isLoss = Number(data.lose) > 0;
            if (!isLoss) {
              updateStatistics({...response.data, win: new Big(new Big(response.data.balance ?? 0)).minus(prevState ?? 0).toFixed(8)}, 'balls');
            } else updateStatistics({...response.data, lose: new Big(new Big(response.data.balance ?? 0)).minus(prevState ?? 0).toFixed(8)}, 'balls');

            return new Big(response.data.balance ?? 0).toFixed(8)
          });
          setPaymentMethods(prevState =>
              prevState?.map(paymentMethod =>
                  paymentMethod.id === selectedPaymentMethod?.id
                      ? {...paymentMethod, balances: {...paymentMethod.balances, amount: formatNumber(response.data.balance)}}
                      : paymentMethod)
          );
          setResponseData({
            ...response.data,
            betInfo: {...JSON.parse(response.data.betInfo), gameObject: {
                max: response.data.max,
                sign: response.data.sign,
                coefficient: response.data.coefficient,
                chanceToWin: response.data.chanceToWin
              }, drawnNumber: response.data.drawnNumber, suggestedNumbers: response.data.suggestedNumbers, resultNumber: response.data.resultNumber},
            bet: submitData.bet.toString(),
            suggestedNumbers: submitData.suggestedNumbers.toString(),
            sign: submitData.sign,
          });
        } else if (gameInfoRef.current) {
          gameInfoRef.current.responseData = response.data;
        }
        setLastHonestyControl((prevState) => ({
          ...prevState,
          clientSeed: data.clientSeed,
          serverSeedHash: data.serverSeedHash,
        }));
      }
    }).catch(error => {
      stopAnimationSync();
      betLock.current = false;
      let terminate = false;
      console.log('error:', error);
      if (error?.response?.status) {
        terminate = true;
      }
      if (error.response?.status === responseStatus.HTTP_BAD_REQUEST || error.response?.status === responseStatus.HTTP_ERROR_VALIDATION) {
        closableNotification(error.response.data.error, "error");
      }
      if (error?.response?.status === responseStatus.HTTP_UNAUTHORIZED) {
        closableNotification(error?.response?.data?.detail, 'error');
      }
      if (!gameInfoRef.current.isLeavePage) {
        setResponseData((prevState) => ({ ...prevState, error: true }));
        setErrorData({ error: true, terminate });
      } else if (gameInfoRef.current) {
        gameInfoRef.current.responseData = { ...gameInfoRef.current.responseData, error: true };
        gameInfoRef.current.errorData = { ...gameInfoRef.current.errorData, terminate };
      }
    });
  };

  const handlePlayClick = useCallback(() => {
    const getError = () => {
      if (!balance) {
        return t("topUpYourBalance");
      } else if (!suggestedNumbers?.length) {
        return t("placeYourBet");
      }

      return null;
    };

    const errorMessage = getError();

    if (errorMessage) {
      closableNotification(errorMessage, "error");
    } else {
      toPlay();
    }
  }, [balance, suggestedNumbers?.length, t, toPlay]);

  const sliceDecimal = (valueNumber) => {
    const value = `${valueNumber}`.replaceAll(',', '.');
    if (value && parseFloat(value) && value.includes('.')) {
      let [intPart, decimalPart] = value.split('.');
      if (decimalPart?.length > 3) {
        decimalPart = decimalPart.substring(0, 3);
      }
      if (intPart === '') {
        intPart = 0;
      }
      return [intPart, decimalPart].join('.');
    } else {
      return value;
    }
  }

  const formattedCoefficient = () => {
    return `${submitData.suggestedNumbers === "" ? "0" : (responseData.coefficient ? sliceDecimal(responseData.coefficient) : "0")}x`
  }

  const oddChooseBalls = () => {
    if (isRunMagnet || hotkeysDisabled || chatIsClicked || betLock?.current) return;

    setSubmitData((prevState) => ({...prevState, suggestedNumbers: "[1,3,5,7,9]"}))
  };

  const evenChooseBalls = () => {
    if (isRunMagnet || hotkeysDisabled || chatIsClicked || betLock?.current) return;

    setSubmitData((prevState) => ({...prevState, suggestedNumbers: "[0,2,4,6,8,10]"}))
  };

  const reversChooseBalls = () => {
    if (isRunMagnet || hotkeysDisabled || chatIsClicked || betLock?.current) return;

    let inputArray = JSON.parse(submitData.suggestedNumbers);

    if (!inputArray || inputArray?.length < 1) return setSubmitData((prevState) => ({...prevState, suggestedNumbers: "[0,1,2,3,4,5,6,7,8]"}))

    let fullArray = Array.from({ length: 11 }, (_, i) => i);

    let resultArray = fullArray?.filter(num => !inputArray.includes(num));

    resultArray.reverse();

    setSubmitData((prevState) => ({...prevState, suggestedNumbers: JSON.stringify(resultArray)}))
  };

  const clearChoosesBalls = () => {
    if (isRunMagnet || hotkeysDisabled || chatIsClicked || betLock?.current) return;

    setSubmitData((prevState) => ({...prevState, suggestedNumbers: "[]"}))
  };

  const multiplyBet = () => {
    if (isRunMagnet || hotkeysDisabled || chatIsClicked || betLock?.current) return;

    if (submitData.bet * 2 <= Number(balance) && submitData.bet > 0) {
      const stringValue = (submitData.bet * 2).toFixed(8).toString();
      setSubmitData((prevState) => ({ ...prevState, bet: stringValue }));
    }
  };

  const divideBet = () => {
    if (isRunMagnet || hotkeysDisabled || chatIsClicked || betLock?.current) return;

    if (submitData.bet / 2 >= 0.00000001) {
      const stringValue = (submitData.bet / 2).toFixed(8).toString();
      setSubmitData((prevState) => ({ ...prevState, bet: stringValue }));
    }
  };

  const setMinBet = () => {
    if (isRunMagnet || hotkeysDisabled || chatIsClicked || betLock?.current) return;

    setSubmitData((prevState) => ({ ...prevState, bet: "0.00000001" }));
  };

  const setMaxBet = () => {
    if (isRunMagnet || hotkeysDisabled || chatIsClicked || betLock?.current) return;

    setSubmitData((prevState) => ({ ...prevState, bet: formatNumber(balance) }));
  };

  const rollBalls = () => {
    if (isRunMagnet || hotkeysDisabled || chatIsClicked || !rollButtonRef?.current || betLock?.current) return;

    rollButtonRef.current.click();
  };

  useHotkeys('q', oddChooseBalls, { enabled: (!hotkeysDisabled && !autoModeIsStart && !chatIsClicked)}, [hotkeysDisabled, isRunMagnet, autoModeIsStart, chatIsClicked]);
  useHotkeys('w', evenChooseBalls, { enabled: (!hotkeysDisabled && !autoModeIsStart && !chatIsClicked) }, [hotkeysDisabled, isRunMagnet, autoModeIsStart, chatIsClicked]);
  useHotkeys('e', reversChooseBalls, { enabled: (!hotkeysDisabled && !autoModeIsStart && !chatIsClicked) }, [hotkeysDisabled, isRunMagnet, submitData, autoModeIsStart, chatIsClicked]);
  useHotkeys('r', clearChoosesBalls, { enabled: (!hotkeysDisabled && !autoModeIsStart && !chatIsClicked) }, [hotkeysDisabled, isRunMagnet, autoModeIsStart, chatIsClicked]);
  useHotkeys('a', multiplyBet, { enabled: (!hotkeysDisabled && !autoModeIsStart && !chatIsClicked) }, [hotkeysDisabled, isRunMagnet, submitData, autoModeIsStart, chatIsClicked]);
  useHotkeys('s', divideBet, { enabled: (!hotkeysDisabled && !autoModeIsStart && !chatIsClicked) }, [hotkeysDisabled, isRunMagnet, submitData, autoModeIsStart, chatIsClicked]);
  useHotkeys('d', setMinBet, { enabled: (!hotkeysDisabled && !autoModeIsStart && !chatIsClicked) }, [hotkeysDisabled, isRunMagnet, submitData, autoModeIsStart, chatIsClicked]);
  useHotkeys('f', setMaxBet, { enabled: (!hotkeysDisabled && !autoModeIsStart && !chatIsClicked) }, [hotkeysDisabled, isRunMagnet, submitData, autoModeIsStart, chatIsClicked]);
  useHotkeys('space', rollBalls, { enabled: (!hotkeysDisabled && !autoModeIsStart && !chatIsClicked), preventDefault: true }, [hotkeysDisabled, isRunMagnet, submitData, autoModeIsStart, chatIsClicked]);

  return (
    <StyledBallsBetOptions>
      <div className="wrapper-group">
        <InputGroup
          label={t("bet")}
          type="text"
          name="bet"
          value={submitData?.bet}
          onChange={handleChange}
          position="center"
          betAction={
            <BetAction
              isPlay={isRunMagnet}
              value={submitData.bet}
              handleChange={handleChange}
              setValue={(data) => setSubmitData((prevState) => ({ ...prevState, bet: data }))}
              max={Number(balance)}
              min="0.00000001"
            />}
          readOnly={isRunMagnet || autoModeIsStart}
          // error={
          //   submitData.bet < 0.00000001 || submitData.bet > submitData.paymentMethod?.balances?.amount}
        />
        <InputGroup
          label={t("chanceToWin")}
          type="text"
          value={`${responseData.chanceToWin ?? "0"}%`}
          name="chanceToWin"
          readOnly
        />
        <InputGroup
          label={t("win")}
          type="text"
          value={!isNaN(Number(winAmount)) ? Number(winAmount).toFixed(8) : Number(0).toFixed(8)}
          name="win"
          readOnly
        />
        <InputGroup
          label={t("coefficient")}
          type="text"
          value={formattedCoefficient()}
          name="coefficient"
          readOnly
        />
      </div>
      <div className="wrapper-group">
        <StyledButton color={(isRunMagnet || autoModeIsStart || isDisableAutoBet || betLock.current) ? "danger" : "main"} ref={rollButtonRef}
                      onClick={handlePlayClick} disabled={isRunMagnet || autoModeIsStart || isDisableAutoBet || !currentHonestyControl?.[games.balls]?.serverSeedHash || betLock.current}>
          {t("startMagnet")}
        </StyledButton>
        <AutoBetsContainer
          game={GAMES.BALLS}
          toPlay={toPlay}
          isPlay={isRunMagnet}
          responseData={responseData}
          submitData={submitData}
          setSubmitData={setSubmitData}
          setStopAnimation={setIsRunMagnet}
          errorData={errorData}
          setErrorData={setErrorData}
          isMobile={isMobile}
          animationDisabled={animationDisabled}
        />
      </div>
    </StyledBallsBetOptions>
  );
};

export default BallsToPlayContainer;
